import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createI18n } from "vue-i18n";
import history from "connect-history-api-fallback";
import VueSplide from "@splidejs/vue-splide";
import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css'
import "./services/firebase";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './assets/css/styles.css'

const redirectTarget = window.location.pathname.replace(/\/$/, '') === '/merchant-sign-up'
  ? 'https://merchant-v2.paykoko.com/signup'
  : null

if (redirectTarget) {
  window.location.replace(redirectTarget + window.location.search + window.location.hash)
}


//message for the different languages
const messages = {
  en: {
    c: {
      step: "Step",
      kokoHowWorks: "Here's how Koko works.",
      step1Body: "Download the app to shop your most-loved brands.",
      step2Body:
        "Shop online: View the instalments and choose Koko as your payment method.",
      step3Body:
        "Shop in-store: Simply scan the QR code in-store, with your Koko app, and tap to pay.",
      step4Body:
        "Make the first of 3 payments now. Pay the rest over 60 days with 0% interest.",
      gettheapplink: "Get the app directly to your phone",
      yourphone: "Your phone number",
      menu: "For Customers",
      header1: "Buy now pay later with Koko",
      header1_a:
        "Choose Koko when shopping at your favourite retailers and split the cost into 3 easy interest free payments.",
      header2_title1: "Pay how you like",
      header2_title1_a:
        "Enjoy the convenience of getting what you want and paying for it over time - even with your debit card!",
      header2_title2: "3 interest-free payments",
      header2_title2_a:
        "Pay in 3 with Koko through our app. Koko is accepted anywhere, online and offline.",
      header2_title3: "Instant approval",
      header2_title3_a:
        "Get instant approval to a spending limit that'll get you started off quickly.",
      header3: "The all-in-one shopping app.",
      header3_a:
        "Koko is with you wherever and whenever you need it. Koko has got your back, keep up to date with your balance, upcoming payments, and the latest and greatest.",
      headerHowWorks: "Here’s how Koko works.",
      headerHowWorks_a:
        "Koko is with you wherever and whenever you need it. Koko has got your back, keep up to date with your balance, upcoming payments, and the latest and greatest.",
      howWorks_1_content: "Download the app to shop your most-loved brands.",
      howWorks_2_content:
        "Shop online: View the instalments and choose Koko as your payment method.",
      howWorks_3_content:
        "Shop in-store: Simply scan the QR code in-store, with your Koko app, and tap to pay.",
      howWorks_4_content:
        "Make the first of 3 payments now. Pay the rest over 60 days with 0% interest.",
      header4_title1: "Featured Stores",
      header4_title1_a: "Shop at your favourite stores now.",
      header4_title2: "Fashion",
      header4_title2_a: "Treat yourself to everything you’ve been eyeing up.",
      header4_title3: "Electronics",
      header4_title3_a: "The best-sellers on everyone’s radar.",
      header4_title4: "Lifestyle",
      header4_title4_a: "Get what you need, no hassle no stress.",
      header5: "Frequently Asked Questions",
      header5_title1: "What is Koko?",
      header5_title1_a:
        "Koko offers customers to buy now and pay later in-store and online with 3 equal instalments over 60 days with 0% interest. No admin fees, mark-ups or hidden charges!",
      header5_title2: "I am a customer, what happens if I can’t pay on time?",
      header5_title2_a:
        "Sometimes you might need more time to pay – we completely understand! Each Customer will be eligible to receive 2 free reschedules per year. For any excess reschedules, the customer will be charged a flat rate of Rs. 500 which will have to be paid at the time of rescheduling. If the payment of Rs. 500 is unsuccessful, rescheduling will not take place and the installment date would remain the same. The rescheduling of the payment would be applicable to an extension of up to two weeks, and will be requested through the app. A reschedule can be requested up to the day of the original installment due date and can not be requested on the due date.",
      header5_title3: "How will I receive my full refund?",
      header5_title3_a:
        "Once the merchant has initiated refund, we will process the refund amount back to your card (credit or debit) which has been used as the payment method. The refund will be processed instantly from the date the refund has been initiated. It will take 3-5 working days to be credited to your account.",
      header5_title4: "How much am I eligible to spend?",
      header5_title4_a:
        "To ensure safe spending practices, each new purchase is evaluated by our system to determine approval. This takes into account many different factors including time of day, size of the purchase, and any history with Koko. The longer you have been using the in-app shopping feature and the more orders you have successfully repaid, the more likely you will be able to spend more. Restrictions are tighter for ‘new’ shoppers until we get to know you.",
    },
    m: {
      aboutHeader: "Building the Future of Finance",
      aboutBody:
        "Expanding financial access, choice, and control for our customers.",
      menu: "For Merchants",
      header1: "Boost your business with Koko",
      header1_a:
        "Offer your customers a simple way to pay. Let them pay in 3 interest free instalments. Receive your payment within 15 days.",
      header2: "Everyone wins with Koko",
      header2_a:
        "Selling with Koko is proven to boost your sales and make running your business easier.",
      header2_title1: "Quick Start",
      header2_title1_a: "Easily integrable to e-commerce platforms",
      header2_title2: "New Customers",
      header2_title2_a: "We reach out to millions of shoppers nationwide",
      header2_title3: "Dedicated Support",
      header2_title3_a: "Our team is ready to help around the clock",
      header2_title4: "Fraud Risk Removed",
      header2_title4_a:
        "We take full responsibility for collection and fraud risk, so that you can focus on running your business",
      header2_title5: "More power to you",
      header2_title5_a:
        "Offline store integration will enable customers to shop effortlessly",
      header2_title6: "Buyer Protection",
      header2_title6_a: "Risk-free for both you and your customers",
      header2_title7: "Reliable Payments",
      header2_title7_a:
        "Get your full order value paid regardless of whether your customer pays",
      header2_title8: "Settle easily",
      header2_title8_a:
        "Customers can choose to settle with their choice of debit or credit card",
      header3: "How it works for merchants",
      header3_a:
        "It’s business as usual when accepting payments with Koko. Focus on giving your customers the best experience and we’ll take care of the rest.",
      header3_title1: "Easy purchasing",
      header3_title1_a:
        "Give your customers an easy way to pay through Koko both online and offline.",
      header3_title2: "Order Fulfillment",
      header3_title2_a:
        "All orders remain on your own sales platform and you fulfill them as usual.",
      header3_title3: "Get paid",
      header3_title3_a:
        "Receive payment in full into your nominated account in 15 day cycles.",
      header3_title4: "Payment Safety",
      header3_title4_a:
        "Koko carries all collection responsibility and fraud risk for every transaction.",
      header4: "Give your customers financial freedom",
      header4_a:
        "Give your customers what no one else can, the ability to spread the cost of their purchase into 3 interest-free instalments over 60 days.",
      header4_title1: "Instant access",
      header4_title1_a: "to a pre-approved limit. No documents required.",
      header4_title2: "Simple instalments",
      header4_title2_a: "Pay in three, interest free",
      header4_title3: "Use Debit/Credit Card",
      header4_title3_a: "to settle instalments automatically with their card",
      header5: "Sell with Koko",
      header5_a:
        "Seamless integration available for in-store, website and third-party platform transactions.",
      header5_title1: "On your website",
      header5_title1_a: "Integrate with ease on your ecommerce platform",
      header5_title2: "In a physical store",
      header5_title2_a:
        "Swiftly accept payments at your brick and mortar stores.",
      header5_title3: "Sell on social media",
      header5_title3_a: "Converting ‘page likes’ to purchases.",
      header6: "Easy Integration",
      header6_a:
        "Getting up and running with Koko is always hassle-free. We’re staffed and skilled to quickly integrate with your store and payment partners.",
      header7: "Who partners with us",
      header7_a:
        "Sri Lanka’s top brands are using Koko to elevate their payment experience.",
      header8: "Frequently Asked Questions",
      header8_title1: "How do I apply to become a Koko merchant?",
      header8_title1_a:
        "You can reach out to us submit details through our website and our team will be happy to get you started.",
      header8_title2: "What fees will a Koko merchant be charged?",
      header8_title2_a:
        "The merchant fees will include processing fees and commission charges. Please note in the situation of a refund, the commission will be returned to the merchant, however the processing fee charged is non-refundable.",
      header8_title3: "How will Koko settle my payment?",
      header8_title3_a:
        "If no refunds have been requested, Koko will pay the merchant the total amount of all transactions in 15 days cycles. This will be credited to your bank account on the 15th and the last day of each month.",
      header8_title4: "How do I process a refund for my customer?",
      header8_title4_a:
        "You need to apply for a refund through our merchant portal. When the option of refund is selected, Koko will refund any instalment payments made by the customer back to their debit or credit card.",
      header8_title5:
        "How do I receive login credentials for the merchant portal?",
      header8_title5_a:
        "Once you register with Koko, your login credentials will be sent to you by our merchant success team via email.",
      header9: "Sign up to sell more with Koko",
      header9_a:
        "Join Sri Lanka’s top brands to elevate your customer’s payment experience.",
      header9_title1: "Enter your company name",
      header9_title2: "Enter your name",
      header9_title3: "What’s the type of business? ",
      header9_title4: "Enter your phone number",
      header9_title5: "Enter your email",
      header9_title6: "Enter the captcha",
      UNLEASH_SHOPPING:"Unleash shopping freedom for your customers with Koko",
      FROM_STARTUPS: "From Startups to Big Brands, empower your business with Koko's flexible payment solutions. Let customers pay in 3 easy interest free instalments and receive your payment within just 15 days or less.",
      SRI_LANKAN_MERCHANTS:"Sri lankan Merchants",
      SHOPPERS:"Shoppers",
      GLOBAL_BRANDS:"Global Brands",
      GET_STARTED_KOKO_MERCHANT:"Get Started with Koko",
    },

    buttons: {
      submit: "Submit",
      getStarted: "Get Started",
      getAccess: "Get Early Access",
    },
    footer: {
      header1: "For Merchants",
      header2: "Privacy",
      header3: "Terms",
      header4: "Customer",
      header5: "About Us",
      header6: "Careers",
      header7: "Press",
      header8: "Download App",
      header9: "Merchant",
      header10: "Sell With Koko",
      header11: "Merchant Portal",
      header12: "Merchant Login",
    },
  },
  sin: {
    c: {
      step: "පියවර",
      kokoHowWorks: "කොකෝ වැඩ කරන ආකාරය",
      step1Body:
        "ඔබගේ වඩාත්ම කැමති වෙළඳ නාම සමඟ භාණ්ඩ මිලදී ගැනීමට යෙදුම බාගන්න",
      step2Body:
        "මිලදී ගන්න: වාරික බලන්න ස;හ ඔබේ ගෙවීම් ක්‍රමය ලෙස කොකෝ තෝරන්න",
      step3Body:
        "ගබඩාවේ සාප්පු යන්න: ඔබේ කොකෝ යෙදුම සමඟ ගබඩාවේ ඇති QR කේතය පරිලෝකනය කර ගෙවීමට තට්ටු කරන්න.",
      step4Body:
        "ගෙවීම් 3 න් පළමුවැන්න දැන් කරන්න. ඉතිරිය දින 60 කට වැඩි කාලයක් 0% පොලිය සමඟ ගෙවන්න",
      gettheapplink: "ඇප් එක​ ඔබගේ දුරකථනයට ලබා ගන්න",
      yourphone: "ඔබගේ දුරකථන අංකය",
      menu: "පාරිභෝගිකයින් සඳහා",
      header1: "අද මිලදී ගෙන කොකෝ සමග පසුව ගෙවන්න",
      header1_a:
        "ඔබේ ප්‍රියතම වෙළෙන්දන්ගෙන් භාණ්ඩ මිලදී ගන්න, කොකෝ සමග මුළු ගැනුම් වටිනාකමම පහසු පොලී රහිත ගෙවීම් 3 කට බෙදන්න.",
      header2_title1: "ඔබ කැමතිම විදිහට ගෙවන්න",
      header2_title1_a: "ඔබ කැමතිම දේ මිලට ගන්න, ගෙවීම් කාලය දිගු කරගන්න",
      header2_title2: "පොළී නැතුව වාරික 3 න් ගෙවන්න",
      header2_title2_a:
        "අලෙවිසැල් වල, ඔන්ලයින් හරහා හෝ කොකෝ සිටින  ඕනෑම ස්ථානයක දී කොකෝ ඇප් එක හරහා වාරික තුනකින් ගෙවන්න.",
      header2_title3: "ක්ෂණික අනුමැතිය",
      header2_title3_a: "ඔබටම වියදම් සීමාවක්ල එකක් ආරම්භ කරගන්න",
      header3: "සියලූ‍ම සේවාවන් එකම ඇප් එකක් තුලින්",
      header3_a:
        "ඔබට අවශ්‍ය  ඕනෑම වේලාවක කොකෝ ඔබ සමඟ සිටී. කොකෝ ඔබ ගැන බලා ගනීවි. ඔබගේ ශේෂය, ඉදිරියට එන ගෙවීම් සහ නවතම සහ විෂ්මිත දේ සමඟ රැදී සිටින්න.",
      headerHowWorks: "කොකෝ ක්‍රියා කරන ආකාරය මෙන්න",
      headerHowWorks_a:
        "ඔබට අවශ්‍ය  ඕනෑම වේලාවක කොකෝ ඔබ සමඟ සිටී. කොකෝ ඔබ ගැන බලා ගනීවි. ඔබගේ ශේෂය, ඉදිරියට එන ගෙවීම් සහ නවතම සහ විෂ්මිත දේ සමඟ රැදී සිටින්න.",
      howWorks_1_content:
        "ඔබගේ වඩාත්ම කැමති වෙළඳ නාම සමඟ භාණ්ඩ මිලදී ගැනීමට යෙදුම බාගන්න",
      howWorks_2_content:
        "මිලදී ගන්න: වාරික බලන්න සහ ඔබේ ගෙවීම් ක්‍රමය ලෙස කොකෝ තෝරන්න",
      howWorks_3_content:
        "අලෙවිසැල තුල මිලදී ගන්න​: ඔබේ කොකෝ යෙදුම සමඟ අලෙවිසැලේ ඇති QR කේතය ස්කෑන් කර ගෙවීමට ඔබන්න",
      howWorks_4_content:
        "ගෙවීම් 3 න් පළමුවැන්න දැන් කරන්න. ඉතිරිය දින 60 කට වැඩි කාලයක් 0% පොලිය සමඟ ගෙවන්න",
      header4_title1: "විශේෂිත වෙළඳසැල්",
      header4_title1_a: "දැන් ඔබේ ප්‍රියතම වෙළද නාමයන් සමග",
      header4_title2: "විලාසිතා",
      header4_title2_a: "ඔබ පුන පුනා බලා සිටි සෑම දෙයක්ම ඔබේ කරගන්න.",
      header4_title3: "ඉලෙක්ට්‍රොනික උපකරණ",
      header4_title3_a: "සෑම දෙනාගේම කැමතිම අංග",
      header4_title4: "සුවතාවය",
      header4_title4_a: "ඔබට අවශ්‍ය දේ කරදරයක් නැතුව ලබා ගන්න",
      header5: "නිතර අසනු ලබන ප්‍රශ්න",
      header5_title1: "කොකෝ යනු කුමක්ද?",
      header5_title1_a:
        "කොකෝ විසින් ගනුදෙනුකරුවන්ට දැන් මිලදී ගෙන පසුව අලෙවිසැල තුළ සහ අන්තර්ජාලය හරහා සමාන වාරික 3 ක් සමඟ දින 60 ක් තුළ 0% පොළියත් සමඟ ගෙවීමට අවස්ථාව ලබා දෙයි. පරිපාලක ගාස්තු සහ වෙනත් සැඟවුණු ගාස්තු නොමැත!",
      header5_title2:
        "මම ගනුදෙනුකරුවෙක්, මට නියමිත වේලාවට ගෙවීමට නොහැකි වුවහොත් කුමක් සිදුවේද?",
      header5_title2_a:
        "සමහර විට ඔබට ගෙවීමට වැඩි කාලයක් අවශ්‍ය විය හැකිය - අපි සම්පූර්ණයෙන්ම තේරුම් ගනිමු! සෑම පාරිභෝගිකයෙකුටම වසරකට නොමිලෙ 2 වරක් නැවත වාරික පෙළ ගැස්වීමට සුදුසුකම් ලැබේ.  ඕනෑම අතිරික්ත උපලේඛන සඳහා, පාරිභෝගිකයාට රු. 500 ක් නැවත සකස් කිරීමේදී ගෙවිය යුතුය. රු. 500ක් ගෙවීම අසාර්ථක නම් නැවත සකස් කිරීම සිදු නොවන අතර වාරික දිනය එලෙසම පවතී. ගෙවීම නැවත සකස් කිරීම සති දෙකක් දක්වා දීර්ඝ කිරීමකට අදාළ වන අතර යෙදුම හරහා ඉල්ලනු ලැබේ. මුල් වාරිකය නියමිත දිනට පෙර නැවත සකස් කිරීමක් ඉල්ලා සිටිය හැකි අතර නියමිත දිනට ඉල්ලීමක් කළ නොහැක.",
      header5_title3: "මගේ සම්පූර්ණ මුදල් ආපසු ලැබෙන්නේ කෙසේද?",
      header5_title3_a:
        "වෙළෙන්දා මුදල් ආපසු ගෙවීම ආරම්භ කළ පසු, අප ආපසු ගෙවීමේ මුදල ඔබගේ කාඞ්පතට (ක්‍රෙඩිට් හෝ ඩෙබිට්) නැවත තැන්පත් කරන්නෙමු. මුදල් ආපසු ගෙවීම ආරම්භ කළ දින සිට ක්ෂණිකව ආපසු ගෙවීම සිදු කෙරේ. ඔබගේ ගිණුමට නැවත එම මුදල බැර කිරීමට වැඩ කරන දින 3-5 දක්වා කාලයක් ගත වේ.",
      header5_title4: "මට කොපමණ මුදලක් වියදම් කිරීමට හැකිද?",
      header5_title4_a:
        "ආරක්ෂිත වියදම් පිළිවෙත් සහතික කිරීම සඳහා, අනුමැතිය තීරණය කිරීම සඳහා සෑම නව මිලදී ගැනීමක්ම අපගේ පද්ධතිය විසින් ඇගයීමට ලක් කරනු ලැබේ. මෙය මිලදී ගැනීමේ ප්‍රමාණය සහ කොකෝ සමඟ ඇති ඉතිහාසය ඇතුළුව විවිධ සාධක ඇගයීමට ලක් වේ. අපගේ ඇප් එක තුළ ඇති මිලදී ගනීමේ විශේෂාංගය ඔබ විසින් වැඩියෙන් භාවිතා කර, ඇණවුම් ආපසු ගෙවීමේ සාර්ථකත්වය මත ඔබට වැඩි මුදලක් වියදම් කිරීමට හැකි වනු ඇත. අපි ඔබව හඳුනා ගන්නා තෙක්  ර්‍ණනවක” සාප්පු හිමියන්ට විවිධ සීමා කිරීම් පැනවේ.",
    },
    m: {
      menu: "වෙළෙන්දන් සඳහා",
      header1: "කොකෝ සමඟ ඔබේ ව්‍යාපාරය දියුණු කරගන්න",
      header1_a:
        "ඔබේ ගනුදෙනුකරුවන්ට ගෙවීමට සරල ක‍්‍රමයක් ලබා දෙන්න. පොළී රහිත වාරික 3 කින් ගෙවීමේ පහසුව ඔවුන්ට ලබා දෙන්න. ඔබේ විකුණුම් මුදල දින 15 ක් ඇතුළත ලබා ගන්න.",
      header2: "කොකෝ සමඟ සැවොම දිනුම්",
      header2_a:
        "ණධණධ සමඟ විකුණුම් ඉහළ නැංවීමට සහ ඔබේ ව්‍යාපාරය කරගෙන යාම පහසු කරගැනීමට හැකි බව තහවුරු කරායි.",
      header2_title1: "ඉක්මන් ආරම්භය",
      header2_title1_a: "ඊ-වාණිජ්‍ය වේදිකාවලට පහසුවෙන් සම්බන්ධ විය හැකිය",
      header2_title2: "නව පාරිභෝගිකයන්",
      header2_title2_a:
        "අපි රට පුරා සිටින මිලියන සංඛ්‍යාත පාරිභෝගිකයන් සම්බන්ධ කර ගන්නෙමු",
      header2_title3: "කැපවූ සහාය",
      header2_title3_a: "අපගේ කණ්ඩායම පැය 24 පුරාම උදව් කිරීමට සූදානම්",
      header2_title4: "වංචා අවදානම් නැත",
      header2_title4_a:
        "ගෙවීමටල එකතු කිරීම සහ වංචා අවදානම පිළිබඳ සම්පූර්ණ වගකීම අපි භාර ගන්නෙමු, එවිට ඔබට ඔබේ ව්‍යාපාරය පවත්වාගෙන යාම කෙරෙහි වැඩියෙන් අවධානය යොමු කළ හැකිය",
      header2_title5: "ඔබට වැඩි ශක්තියක්",
      header2_title5_a:
        "වෙළඳසැල් ඒකාබද්ධ කිරීම මඟින් ගනුදෙනුකරුවන්ට පහසුවෙන් සාප්පු යෑමට හැකි වේ",
      header2_title6: "ගැනුම්කරුගේ ආරක්ෂාව",
      header2_title6_a: "ඔබට සහ ඔබේ ගනුදෙනුකරුවන්ට කිසිදු අවදානමක් නැත",
      header2_title7: "විශ්වසනීය ගෙවීම්",
      header2_title7_a:
        "ඔබේ ගනුදෙනුකරු ගෙවන්නේද යන්න නොසලකා ඔබගේ සම්පූර්ණ ඇණවුම් වටිනාකමම ලබා ගන්න",
      header2_title8: "පහසුවෙන් ගෙවන්න",
      header2_title8_a:
        "ගනුදෙනුකරුවන්ට ඔවුන්ගේ ඩෙබිට් හෝ ක්‍රෙඩිට් කාඞ් මගින්  ගෙවීමට තීරණය කල හැක",
      header3: "වෙළෙන්දන් සඳහා එය ක්‍රියා කරන ආකාරය",
      header3_a:
        "කොකෝ සමඟ ගෙවීම් භාර ගැනීම එදිනෙදා ව්‍යාපාර කටයුත්තකි. ඔබේ ගනුදෙනුකරුවන්ට හොඳම අත්දැකීම ලබා දීම කෙරෙහි ඔබ අවධානය යොමු කරන්න, ඉතිරිය අපි බලා ගන්නෙමු.",
      header3_title1: "පහසුවෙන් මිලදී ගන්න",
      header3_title1_a:
        "ඔබේ ගනුදෙනුකරුවන්ට අන්තර්ජාලය මගින් හා සාප්පුව හරහා යන දෙඅංශයෙන්ම කොකෝ හරහා ගෙවීමට පහසු ක්‍රමයක් ලබා දෙන්න.",
      header3_title2: "ඇණවුම සම්පූර්ණ කිරීමට",
      header3_title2_a:
        "සියලූ‍ම ඇණවුම් ඔබේම වෙළද වේදිකාවක පවතින අතර ඔබට  ඒවා සුපුරුදු පරිදි සපයනු ලබයි",
      header3_title3: "මුදල් ගෙවීම",
      header3_title3_a:
        "ඔබගේ නම් කරන ලද ගිණුමට සෑම දින 15 කට වරක් ගෙවීම් ලැබෙනු ඇත",
      header3_title4: "සුරක්ෂිත භාවය",
      header3_title4_a:
        "සෑම ගනුදෙනුවකටම අදාල මුදල එකතු කිරීමේ වගකීම සහ වංචා අවදානම කොකෝ විසින් දරනු ලැබේ.",
      header4: "ඔබේ පාරිභෝගිකයන්ට අවශ්‍ය මූල්‍ය නිදහස ලබා දෙන්න",
      header4_a:
        "ඔබේ පාරිභෝගිකයන්ට වෙනත් කිසිවෙකු ලබා නොදෙන පහසුකම් ලබා දෙන්න, ඔවුන්ගේ මිලදී ගැනීමේ පිරිවැය දින 60 ක් තුළ පොළී රහිත වාරික 3 කට ව්‍යාප්ත කිරීමේ හැකියාව ලබාදෙන්න.",
      header4_title1: "ක්ෂණික ප්‍රවේශය",
      header4_title1_a: "කලින් අනුමත කළ සීමාවකට. ලියකියවිලි අවශ්‍ය නොවේ.",
      header4_title2: "සරල වාරික",
      header4_title2_a: "පොළී රහිතව, වාරික තුනෙන් ගෙවන්න",
      header4_title3: "ඩෙබිට් සහ ක්‍රෙඩිට් පත භාවිතා කරන්න",
      header4_title3_a: "වාරික ඔවුන්ගේ කාඩ්පත සමඟ ස්වයංක්‍රීයව පියවීමට",
      header5: "කොකෝ සමඟ විකුණුම් කටයුතු සිදුකරන්න",
      header5_a:
        "අලෙවිසැල, වෙබ් අඩවිය සහ තෙවන පාර්ශවීය වේදිකා ගනුදෙනු සඳහා බාධාවකින් තොරව ඒකාබද්ධ වීම.",
      header5_title1: "ඔබේ වෙබ් අඩවිය",
      header5_title1_a: "ඔබේ ඊ-වාණිජ්‍ය වේදිකාවේ පහසුවෙන් සම්බන්ධ වන්න",
      header5_title2: "අලෙවිසැලක් තුළ",
      header5_title2_a: "පහසුවෙන් ඔබේ භෞතික වෙළදසැලේදී ගෙවීම් භරගන්න",
      header5_title3: "සමාජ මාධ්‍ය ජාලා තුලින් විකිණීම් කටයුතු කරන්න",
      header5_title3_a:
        "සමාජ පිටුවට ලැබෙන කැමත්ත මිලදී ගැනීම් බවට පරිවර්තනය කිරීම.",
      header6: "පහසු ඒකාබද්ධතාවය",
      header6_a:
        "කොකෝ සමඟ කටයුතු සිදු කිරීම සැමවිටම කරදරයකින් තොරය. ඔබගේ වෙළඳසැල සහ ගෙවීම් හවුල්කරුවන් සමඟ ඉක්මණින් සම්බන්ධ වීම අපගේ දක්ෂ කාර්ය මණ්ඩලය මගින් සිදු වේ.",
      header7: "අප සමඟ හවුල් වන්නේ කවුද?",
      header7_a:
        "ශ්‍රී ලංකාවේ ඉහළම වෙළඳ නාම, ඔවුන්ගේ ගෙවීම් අත්දැකීම් ඉහළ නැංවීම සඳහා කොකෝ භාවිතා කරයි.",
      header8: "නිතර අසනු ලබන ප්‍රශ්න",
      header8_title1: "කොකෝ සමග වෙළෙන්දෙකු වීමට මා ඉල්ලූ‍ම් කරන්නේ කෙසේද?",
      header8_title1_a:
        "ඔබට merchantdesk@paykoko.com හරහා හෝ අපගේ වෙබ් අඩවිය හරහා විස්තර ඉදිරිපත් කළ හැකි අතර ඔබගේ සේවාවන් ආරම්භ කිරීමට සහාය ලබාදීම පිළිබද අපගේ කණ්ඩායම සතුටු වනු ඇත.",
      header8_title2: "කොකෝ වෙළෙන්දෙකුගෙන් අය කෙරෙන ගාස්තු මොනවාද?",
      header8_title2_a:
        "වෙළඳ ගාස්තු සඳහා සැකසුම් ගාස්තු සහ කොමිස් ගාස්තු ඇතුළත් වේ. කරුණාකර මතක තබා ගන්න, මුදල් ආපසු ගෙවීමේ තත්වයක් තුළ, කොමිස් මුදල වෙළෙන්දා වෙත ආපසු ලබා දෙනු ඇත, කෙසේ වෙතත් අයකරනු ලබන සැකසුම් ගාස්තුව ආපසු නොගෙවනු ලැබේ.",
      header8_title3: "කොකෝ මගේ ගෙවීම පියවන්නේ කෙසේද?",
      header8_title3_a:
        "මුදල් ආපසු ගෙවීමක් ඉල්ලා නොමැති නම්, කොකෝ විසින් වෙළෙන්දාට දින 15 ක කාලයක් තුළ සියලූ‍ම ගනුදෙනු වල මුළු මුදල ගෙවනු ඇත. මෙය සෑම මසකම 15 වන සහ අවසාන දිනවල ඔබගේ බැංකු ගිණුමට බැර කරනු ලැබේ.",
      header8_title4: "මගේ ගනුදෙනුකරුට මුදල් ආපසු ගෙවීමක් කරන්නේ කෙසේද?",
      header8_title4_a:
        "අපගේ වෙළඳ ගෙවීම් දොරටුව හරහා මුදල් ආපසු ලබා ගැනීම සඳහා ඔබ ඉල්ලූ‍ම් කළ යුතුය. මුදල් ආපසු ගෙවීමේ විකල්පය තෝරාගත් විට, කොකෝ විසින් පාරිභෝගිකයා විසින් කරන ලද  ඕනෑම වාරික ගෙවීමක් ඔවුන්ගේ ඩෙබිට් හෝ ක්‍රෙඩිට් කාඞ්පතට ආපසු ගෙවනු ලැබේ.",
      header8_title5:
        "merchant portal සඳහා පුරනය වීමේ තොරතුරු ලබා ගන්නේ කෙසේද?",
      header8_title5_a:
        "ඔබ කොකෝ සමඟ ලියාපදිංචි වූ පසු, ඔබේ පිවිසුම් තොරතුරු අපගේ වෙළඳ සාර්ථක කණ්ඩායම විසින් විද්‍යුත් තැපෑලෙන් ඔබට එවනු ලැබේ.",
      header9: "කොකෝ සමඟ තව තවත් විකිණීම් සඳහා ලියාපදිංචි වන්න",
      header9_a:
        "ඔබේ ගනුදෙනුකරුගේ ගෙවීම් අත්දැකීම් ඉහළ නැංවීමට ශ්‍රී ලංකාවේ ඉහළම වෙළඳ නාම සමඟ සම්බන්ධ වන්න.",
      header9_title1: "ඔබේ සමාගමේ නම ඇතුළත් කරන්න",
      header9_title2: "ඔබේ නම ඇතුළත් කරන්න",
      header9_title3: "ව්‍යාපාර වර්ගය කුමක්ද?",
      header9_title4: "ඔබගේ දුරකථන අංකය ඇතුළත් කරන්න",
      header9_title5: "ඔබගේ විද්‍යුත් ලිපිනය ඇතුළත් කරන්න",
      header9_title6: "captcha විස්තර ඇතුළු කරන්න",
      UNLEASH_SHOPPING:"Unleash shopping freedom for your customers with Koko",
      FROM_STARTUPS: "From Startups to Big Brands, empower your business with Koko's flexible payment solutions. Let customers pay in 3 easy interest free instalments and receive your payment within just 15 days or less.",
      SRI_LANKAN_MERCHANTS:"Sri lankan Merchants",
      SHOPPERS:"Shoppers",
      GLOBAL_BRANDS:"Global Brands",
      GET_STARTED_KOKO_MERCHANT:"Get Started with Koko",
    },

    buttons: {
      submit: "ඉදිරිපත් කරන්න",
      getStarted: "ආරම්භ කරන්න",
      getAccess: "මූලික ප‍්‍රවේශය ලබා ගන්න",
    },
    footer: {
      header1: "වෙළෙන්දන් සඳහා",
      header2: "රහස්යතා ප්රතිපත්තිය",
      header3: "කොන්දේසි",
      header4: "පාරිභෝගිකයන්",
      header5: "අපේ සමාගම",
      header6: "වෘත්තීන්",
      header7: "ප්‍රවෘත්ති",
      header8: "ඇප් එක​​ ඩවුන්ලෝඩ් කරන්න",
      header9: "වෙළඳුන් ",
      header10: "කොකෝ සමඟ විකුණන්න",
      header11: "වෙළඳ ද්වාරය",
      header12: "වෙළෙන්දන්ගේ පිවිසුම",
    },
  },

  tam: {
    c: {
      step: "படி",
      kokoHowWorks: "கோகோ எவ்வாறு செயல்படுகிறது என்பது இங்கே",

      step1Body:
        "உங்களுக்கு மிகவும் பிடித்த பிராண்டுகளில் ஷாப்பிங் செய்ய கோகோ பயன்பாட்டைப் பதிவிறக்கவும்.",
      step2Body:
        "ஆன்லைனில் ஷாப்பிங் செய்யுங்கள்: தவணைகளைக் கண்டறிந்து உங்கள் கட்டண முறையாக கோகோவைத் தேர்வுசெய்க.",
      step3Body:
        "கடையில் ஷாப்பிங் செய்யுங்கள்: உங்கள் கோகோ பயன்பாட்டைக் கொண்டு கடையில் உள்ள QR குறியீட்டை ஸ்கேன் செய்து, பணம் செலுத்த தட்டவும்.",
      step4Body:
        "3 கொடுப்பனவுகளில் முதல் ஒன்றை இப்போது செய்யுங்கள். மீதமுள்ளதை 60 நாட்களுக்கு மேல் 0% வட்டியுடன் செலுத்துங்கள்.",
      gettheapplink: "பயன்பாட்டை உங்கள்; தொலைபேசியில் நேரடியாகப் பெறுங்கள்",
      yourphone: "உங்கள் தொலைபேசி எண்",
      menu: "வாடிக்கையாளர்களுக்கு",
      header1: "இப்போது வாங்கவும், பின்னர் கோகோவுடன் பணம் செலுத்தவும்",
      header1_a:
        "உங்களின் விருப்புக்குரிய சில்லறை வர்த்தகர்களிடம் கொள்வனவு செய்யும் போது Koko வை தெரிவு செய்து உங்கள் கொடுப்பனவை 3 தடவைகளில் வட்டியின்றி செலுத்துங்கள். ",
      header2_title1: "நீங்கள் விரும்பியவாறு பணம் செலுத்துங்கள் ",
      header2_title1_a:
        "நீங்கள் விரும்பியதைப் பெறவும் உங்களின் கொடுப்பனவை பரவலாக்கவும் ",
      header2_title2: "3 வட்டியற்ற கொடுப்பனவுகள் ",
      header2_title2_a:
        "எமது செயலியைப் பயன்படுத்தி 3 தடவைகளில் முழமழ ஊடாக பணம் செலுத்துங்கள், இது இணையம் மற்றும் இணையம் அற்ற எல்லா நிலைகளிலும் ஏற்கப்படும். ",
      header2_title3: "உடனடி அனுமதி ",
      header2_title3_a:
        "எல்லை ஒன்றுக்குள் செலவழிப்பதற்கு நீங்கள் விரைவாக ஆரம்பிக்கலாம். ",
      header3: "அனைத்து விடயங்களையும் கொண்ட n~hப்பிங் செயலி ",
      header3_a:
        "Koko மட்டுமே உங்களுக்கு எங்கும் எந்நேரமும் தேவையானது. அது உங்களைப் பாதுகாக்கும், உங்களின் மிகுதி, எதிர்வரும் கொடுப்பனவுகள், என்பவற்றை உரிய நேரத்தில் சிறப்பாக வழங்கும். ",
      header4_title1: "இயல்பான கடைகள் ",
      header4_title1_a:
        "உங்களுக்கு விருப்பமான கடைகளில் தற்பொழுது கொள்வனவு செய்யுங்கள் ",
      header4_title2: "பெ~ன் ",
      header4_title2_a: "நீங்கள் விரும்பும் அனைத்தையும் வாங்குங்கள் ",
      header4_title3: "இலத்திரனியல் உபகரணங்கள் ",
      header4_title3_a:
        "அனைவரினதும் எதிர்பார்ப்பிலும் உள்ள சிறப்பாக விற்பனையாகும் பொருட்கள் ",
      header4_title4: "வாழ்க்கைப்பாணி ",
      header4_title4_a:
        "உங்களுக்கு தேவையானதைப் பெற்றுக்கொள்ளுங்கள், அவசரமில்லை, அழுத்தமில்லை",
      header5: "அடிக்கடி கேட்கப்படும் கேள்விகள் ",
      header5_title1: "Koko என்றால் என்ன? ",
      header5_title1_a:
        "வாடிக்கையாளர்களுக்கு தற்போது கொள்வனவு செய்து பணத்தினை 60 நாட்களுக்கு மூன்று சமமான கொடுப்பனவுகளாக வட்டியின்றி வழங்கும் வசதியை Koko வழங்குகின்றது. எந்தவொரு நிருவாகச் செலவு, சேர்க்கப்பட்ட கட்டணங்கள் அல்லது மறைவான கட்டணங்களோ அறவிடப்படுவதில்லை! ",
      header5_title2:
        "நான் ஒரு வாடிக்கையாளர், உரிய நேரத்தில் என்னால் பணம் செலுத்த முடியாமல் போனால் என்ன நடக்கும்?",
      header5_title2_a:
        "சில வேளைகளில் பணம் செலுத்துவதற்கு உங்களுக்கு அதிக காலம் தேவைப்படலாம் - அதனை நாம் முழுமையாகப் புரிந்து கொள்கின்றோம்! ஒவ்வொரு வாடிக்கையாளருக்கும் வருடத்துக்கு இரண்டு தடவைகள் கொடுப்பனவு ஒன்றை மீள ஒழுங்கமைக்கும் வாய்ப்பு இலவசமாக வழங்கப்படும். மேலதிக மீள் ஒழுங்கமைப்பு ஒவ்வொன்றுக்கும் வாடிக்கையாளர் மீள் ஒழுங்கமைப்பு செய்ய ரூபாய் 500 நிலையான கட்டணமாக அறவிடப்படும். இப்பணம் மீள் ஒழுங்கமைப்புச் செய்யும் வேளை செலுத்தப்பட வேண்டும். இந்த 500 ரூபாய் கட்டணம் செலுத்தப்படவில்லையாயின், மீள் ஒழுங்கமைப்பு இடம்பெறாது என்பதுடன் செலுத்த வேண்டிய திகதி மாற்றமடையாமல் காணப்படும். இந்த மீள் ஒழுங்கமைப்பு வசதி மூலம் கொடுப்பனவு செலுத்துதல் அதிக பட்சம் இரண்டு வாரங்கள் வரை பிற்போடப்படலாம், அத்துடன் இந்த மீள் ஒழுங்கமைப்புக் கோரிக்கை செயலியின் ஊடாகவே மேற்கொள்ளப்பட வேண்டும். இந்த மீள் ஒழுங்கமைப்புக்கான கோரிக்கை கொடுப்பனவுத் திகதிக்கு முன்னதாக மேற்கொள்ளப்பட வேண்டும், அது கொடுப்பனவுத் திகதியன்று மேற்கொள்ளப்பட முடியாது.  ",
      header5_title3: "எனது முழுமையான மீள் பணம் பெறுதல் எவ்வாறு இடம் பெறும்? ",
      header5_title3_a:
        "விற்பனையாளர் ஒருவர் மீள் பணம் வழங்குதலை ஆரம்பம் செய்த பின்னர், நாம் உங்களின் அந்த மீள வழங்கப்படும் பணத்தை உங்களின் அட்டைக்கு (டெபிட் அல்லது கிரடிட் அட்டை) அனுப்புவது மீள் பணம் வழங்கப்படும் முறையாக அமைந்துள்ளது. மீளப் பணம் வழங்கும் செயன்முறை அது வழங்கப்பட்ட திகதியன்றே ஆரம்பித்து விடும். இது உங்களின் வங்கிக் கணக்கை வந்தடைய 3-5 பணிநாட்கள் தேவைப்படும். ",
      header5_title4: "நான் செலவழிக்க தகுதியான பணத்தின் தொகை என்ன? ",
      header5_title4_a:
        "பாதுகாப்பான செலவிடல் நடைமுறையை உறுதி செய்வதற்காக, ஒவ்வொரு கொள்வனவுக்கான அனுமதியையும் வழங்குவதற்காக அக்கொள்வனவு எங்களது முறைமையினால் மீளாய்வு செய்யப்படும். இம்மீளாய்வின் போது கொள்வனவு நாளின் நேரம், கொள்வனவின் அளவு மற்றும் Koko இனைப் பயன்படுத்தி மேற்கொள்ளப்பட்ட கொள்வனவுகளின் வரலாறு உள்ளிட்ட பல காரணிகள் கருத்திற்கொள்ளப்படும். இந்த செயலியை நீங்கள் நீண்ட காலமாகப் பயன்படுத்துதல், நீங்கள் வெற்றிகரமாக பணம் வழங்கிய கொள்வனவுகளின் எண்ணிக்கை அதிகமாக இருக்கும் நிலையில் உங்களால் அதிகமாக செலவழிக்கும் அனுமதி பெறும் வாய்ப்புகள் அதிகமாகும். புதிய கொள்வனவாளர்கள் பற்றி நாம் அறிந்து கொள்ளும் வரை எமது கட்டுப்பாடுகள் இறுக்கமானவை. ",
        
    },
    m: {
      menu: "வணிகர்களுக்கு",
      header1: "Koko வுடன் இணைந்து உங்கள் வியாபாரத்தை மேம்படுத்துங்கள் ",
      header1_a:
        "உங்களின் வாடிக்கையாளர்களுக்கு பணம் செலுத்துவதற்கான எளிய வழியொன்றை வழங்குங்கள். அவர்களை 3 வட்டியற்ற தவணைகளில் பணம் செலுத்துவதற்கு அனுமதி வழங்குங்கள். உங்களின் பெறுவனவுகளை 15 நாட்களுக்குள் பெற்றுக்கொள்ளுங்கள். ",
      header2: "முழமழ வுடன் இணைந்து அனைவரும் வெற்றியடைகின்றனர். ",
      header2_a:
        "Koko வுடன் இணைந்து விற்பனை செய்வது உங்களின் விற்பனையை அதிகரிப்பது நிரூபிக்கப்பட்டுள்ளதுடன் உங்களின் வியாபாரத்தை இலகுவாக நடத்திச் செல்ல அது உதவும். ",
      header2_title1: "துரிதமான ஆரம்பம் ",
      header2_title1_a:
        "ந-உழஅஅநசஉந இயங்கு தளங்களுடன் இலகுவாக இணைக்கப்படக் கூடியது. ",
      header2_title2: "புதிய வாடிக்கையாளர்கள் ",
      header2_title2_a:
        "நாடளாவிய ரீதியில் நாம் மில்லியன் கணக்கான கொள்வனவாளர்களைச் சென்றடைகின்றோம்.",
      header2_title3: "அர்ப்பணிப்பு மிக்க ஆதரவு ",
      header2_title3_a:
        "எந்நேரமும் உங்களுக்கு உதவ எமது அணி தயார்நிலையில் உள்ளது.",
      header2_title4: "மோசடி அபாயம் அகற்றப்பட்டுள்ளது. ",
      header2_title4_a:
        "பணம் சேகரிப்புக்கான மற்றும் மோசடி அபாயமின்மைக்கான முழுப்பொறுப்பையும் நாங்கள் ஏற்கிறோம், எனவே, நீங்கள் வர்த்தகத்தை நடத்திச் செல்வதில் கவனம் செலுத்த முடியும். ",
      header2_title5: "உங்களுக்கு அதிக சக்தி கிடைக்கின்றது. ",
      header2_title5_a:
        "இணையம் இல்லாத நிலையிலும் கடையினை இணைப்பது வாடிக்கையாளர்கள் இலகுவாக கொள்வனவு செய்வதை இலகுவாக்கும். ",
      header2_title6: "வாங்குவோர் பாதுகாப்பு ",
      header2_title6_a:
        "உங்களுக்கும் உங்கள் வாடிக்கையாளர்களுக்கும் அபாயம் இல்லாத நிலை ",
      header2_title7: "நம்பத்தகுந்த கொடுப்பனவு ",
      header2_title7_a:
        "உங்களின் முழுமையான விற்பனைப் பெறுமதியை வாடிக்கையாளர் கொடுத்தாலும் கொடுக்காவிட்டாலும் பெற்றுக்கொள்ளுங்கள் ",
      header2_title8: "இலகுவாக கொடுத்து முடியுங்கள்",
      header2_title8_a: "விற்பனையாளர்களுக்கு அது எவ்வாறு செயற்படுகின்றது? ",
      header3_a:
        "Koko உடன் கொடுப்பனவுகளை ஏற்றுக்கொள்ளும் போது வியாபாரம் வழமை போன்றே இடம்பெறுகின்றது. வாடிக்கையாளருக்கு சிறந்த அனுபவத்தை வழங்குவதில் மாத்திரம் நீங்கள் கவனம் செலுத்துங்கள், ஏனையவற்றை நாங்கள் கவனித்துக்கொள்கின்றோம். ",
      header3_title1: "இலகுவான கொள்வனவு ",
      header3_title1_a:
        "இணையம் மற்றும் இணையமற்ற நிலைகளில் உங்கள் வாடிக்கையாளர்கள் Koko ஊடாக கொடுப்பனவுகளை வழங்கும் இலகுவான வழியொன்றை அவர்களுக்கு வழங்குங்கள். ",
      header3_title2: "ஆர்டர்களை நிறைவேற்றுதல் ",
      header3_title2_a:
        "அனைத்து கொள்வனவு ஓடர்களும் உங்களின் விற்பனை இயங்குதளத்திலேயே காணப்படுவதுடன் அவற்றை நீங்கள் வழமை போன்றே வழங்கலாம். ",
      header3_title3: "கொடுப்பனவைப் பெற்றுக்கொள்ளுங்கள்",
      header3_title3_a:
        "15 நாள் கால இடைவெளிகளில் நீங்கள் குறிப்பிடும் கணக்குக்கு கொடுப்பனவை முழுமையாக பெற்றுக்கொள்ளுங்கள் ",
      header3_title4: "கொடுப்பனவுப் பாதுகாப்பு ",
      header3_title4_a:
        "ஒவ்வொரு கொடுக்கல் வாங்கல் மற்றும் மோசடி அபாயம் என்பவற்றுக்கான பொறுப்புகளை முழமழ ஏற்கின்றது. ",
      header4:
        "உங்களின் வாடிக்கையாளர்களுக்கு நிதியியல் சுதந்திரத்தை வழங்குங்கள்",
      header4_a:
        "மற்றவர்களால் வழங்க முடியாத ஒன்றை உங்கள் வாடிக்கையாளர்களுக்கு வழங்குங்கள், அதாவது கொடுப்பனவுகளை 60 நாட்களில் 3 தடவைகளில் வட்டியின்றி வழங்குவதற்கு அவர்களுக்கு இயலுமையை வழங்குங்கள். ",
      header4_title1: "உடனடி அணுகல் ",
      header4_title1_a:
        "முன் அனுமதி வழங்கப்பட்ட கொடுப்பனவு மட்டம் ஒன்றுக்கு. ஆவணங்கள் தேவையில்லை ",
      header4_title2: "எளிமையான தவைணக் கொடுப்பனவுகள் ",
      header4_title2_a: "மூன்று தடவைகளில் பணம் வழங்குங்கள், வட்டியில்லை ",
      header4_title3: "டெபிட் ஃ கிரடிட் அட்டைகளைப் பயன்படுத்துக ",
      header4_title3_a:
        "தவணைக் கொடுப்பனவுகளை தன்னியக்கமாக தமது அட்டையைப் பயன்படுத்தி செலுத்துவதற்கு ",
      header5: "முழமழ உடன் விற்பனை செய்யுங்கள் ",
      header5_a:
        "மூன்றாம் தரப்பு இயங்குதளக் கொடுக்கல் வாங்கல்கள் மற்றும் கடைகளில் இடம்பெறும் கொடுக்கல் வாங்கல்களுக்கு ஒன்றிணைந்த ஒருங்கிணைப்பு ",
      header5_title1: "உங்களின் இணையத்தளத்தில் ",
      header5_title1_a:
        "உங்களின் ந-உழஅஅநசஉந இயங்குதளத்துடன் இலகுவான ஒன்றிணையுங்கள் ",
      header5_title2: "பௌதீகக் கடை ஒன்றில் ",
      header5_title2_a:
        "உங்களின் கடைக்கட்டடத்தில் விரைவாக கொடுப்பனவுகளை ஏற்றுக்கொள்ளுங்கள் ",
      header5_title3: "சமூக ஊடகத்தில் விற்பனை செய்யுங்கள் ",
      header5_title3_a:
        "பக்கத்துக்கு வழங்கப்படும் விருப்புகளை கொள்வனவுகளாக மாற்றுதல் ",
      header6: "இலகுவான இணைப்பு ",
      header6_a:
        "முழமழ உடன் இணைவது மற்றும் அதை தொடர்ந்து நடத்துவது சிக்கல் அற்றது. உங்களின் கொடுப்பனவு பங்காளர்களை உங்களின் கடையுடன் இணைப்பதற்கு அவசியமான ஆளணி மற்றும் திறன்களை நாம் கொண்டுள்ளோம். ",
      header7: "எமது பங்காளர்கள் யார் ",
      header7_a:
        "இலங்கையின் உயர் வர்த்தக நாமங்கள் தமது பெறுவனவு அனுபவத்தை உயர்த்த முழமழ இனைப் பயன்படுத்துகின்றன. ",
      header8: "அடிக்கடி கேட்கப்படும் கேள்விகள் ",
      header8_title1:
        "முழமழ விற்பனையாளர் ஒருவராக என்னால் எவ்வாறு மாற முடியும்? ",
      header8_title2: "ஒரு முழமழ வியாபாரி என்ன கட்டணங்களைச் செலுத்த வேண்டும்? ",
      header8_title2_a:
        "வியாபாரிகள் செலுத்த வேண்டிய கட்டணங்களில் தொடர் செயன்முறைக் கட்டணம் மற்றும் தொடர்பாடல் கட்டணம் என்பன உள்ளடங்குகின்றன. பணத்தை மீள வழங்கும் போது அதற்கான தரகுப்பணம் வியாபாரிக்கே வழங்கப்படும் என்பதைக் கவனத்தில் கொள்க. எவ்வாறாயினும், தொடர் செயன்முறைக் கட்டணம் மீள வழங்கப்பட மாட்டாது. ",
      header8_title3: "எனது கொடுப்பனவை முழமழ எவ்வாறு வழங்கும்? ",
      header8_title3_a:
        "மீள்கொடுப்பனவு எதுவும் கோரப்படாவிட்டால், அனைத்து கொடுக்கல் வாங்கல்களினதும் மொத்தத் தொகையை முழமழ 15 நாள் தவணைகளில் வியாபாரிக்கு வழங்கும். இது உங்களின் வங்கிக் கணக்கில் 15 ஆம் திகதியும் அம்மாதத்தின் கடைசித் தினத்திலும் வரவு வைக்கப்படும்.",
      header8_title4:
        "எனது வாடிக்கையாளருக்கு பணம் மீளக் கொடுத்தலை நான் எவ்வாறு செய்வது? ",
      header8_title4_a:
        "மீள்கொடுப்பனவுக்கான விண்ணப்பம் ஒன்றை நீங்கள் எமது ஆநசஉhயவெ Pழசவயட ஊடாக நீங்கள சமர்ப்பிக்க வேண்டும். மீள் கொடுப்பனவுக்கான தெரிவு தேர்ந்தெடுக்கப்பட்ட பின்னர், வாடிக்கையாளர் மேற்கொண்ட எந்த கொடுப்பனவுத் தவணைக் கட்டணங்களையும் முழமழ மீள வாடிக்கையாளரின் டெபிட் அல்லது கிறடிட் அட்டை ஊடாக அவருக்கு மீள வழங்கும்.  ",
      header8_title5:
        "விற்பனையாளர் பகுதிக்குள் (ஆநசஉhயவெ Pழசவயட) உள்நுழைவதற்கான டுழபin விபரங்களை நான் எவ்வாறு பெறுவது? ",
      header8_title5_a:
        "நீங்கள் முழமழ உடன் பதிவு செய்த பின்னர் உங்கள் டுழபin விபரங்கள் ஆநசஉhயவெ ளுரஉஉநளள அணியினால் உங்களுக்கு மின்னஞ்சல் ஊடாக அனுப்பப்படும். ",
      header9: "அதிகமாக விற்பனை செய்ய முழமழ உடன் இணையுங்கள் ",
      header9_a:
        "உங்களின் வாடிக்கையாளரின் கொடுப்பனவு அனுபவத்தை உயர்த்துவதில் இலங்கையின் உயர் வர்த்தக நாமங்களுடன் நீங்களும் இணைந்து கொள்ளுங்கள். ",
      header9_title1: "உங்களின் கம்பனியின் பெயரைப் பதிவிடுங்கள் ",
      header9_title2: "உங்களின் பெயரைப் பதிவிடுங்கள் ",
      header9_title3: "உங்களின் வியாபார வகை என்ன? ",
      header9_title4: "உங்கள் தொலைபேசி இலக்கத்தை பதிவிடுங்கள் ",
      header9_title5: "உங்கள் மின்னஞ்சலை பதிவிடுங்கள் ",
      header9_title6: "ஊயிவஉhய இனை பதிவிடுங்கள் ",
      UNLEASH_SHOPPING:"Unleash shopping freedom for your customers with Koko",
      FROM_STARTUPS: "From Startups to Big Brands, empower your business with Koko's flexible payment solutions. Let customers pay in 3 easy interest free instalments and receive your payment within just 15 days or less.",
      SRI_LANKAN_MERCHANTS:"Sri lankan Merchants",
      SHOPPERS:"Shoppers",
      GLOBAL_BRANDS:"Global Brands",
      GET_STARTED_KOKO_MERCHANT:"Get Started with Koko",
    },

    buttons: {
      submit: "கையளியுங்கள் ",
      getStarted: "ஆரம்பியுங்கள் ",
      getAccess: "முந்திய அணுகலைப் பெறுங்கள் ",
    },

    footer: {
      header1: "For Merchants",
      header2: "Privacy",
      header3: "Terms",
      header4: "Customer",
      header5: "About Us",
      header6: "Careers",
      header7: "Press",
      header8: "Download App",
      header9: "Merchant",
      header10: "Sell With Koko",
      header11: "Merchant Portal",
      header12: "Merchant Login",
    },
  },
};

// Create VueI18n instance with options
const i18n = new createI18n({
  locale: "en", // set locale
  messages, // set locale messages
});


if (!redirectTarget) {
  createApp(App)
    .use(history)
    .use(i18n)
    .use(store)
    .use(VueSplide)
    .use(router)
    .mount("#app");
}

// change other locale
i18n.locale = "sin";
i18n.locale = "tam";
